import { useState } from 'react';
import PropTypes from 'prop-types';
import AuthForm from './AuthForm';

/**
 * 認證 Modal
 * 可在任何需要登入/註冊的頁面使用
 *
 * 使用範例：
 *   const [showAuth, setShowAuth] = useState(false);
 *   <AuthModal open={showAuth} onClose={() => setShowAuth(false)} onSuccess={() => setShowAuth(false)} />
 */
const AuthModal = ({ open, onClose, onSuccess, defaultMode = 'login' }) => {
    const [mode, setMode] = useState(defaultMode);

    if (!open) return null;

    const handleSuccess = (user) => {
        onSuccess?.(user);
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
        >
            <div className="w-full max-w-[430px] bg-[var(--color-surface)] relative overflow-hidden rounded-[18px] shadow-xl flex flex-col py-8 px-[35px]">
                {/* 關閉按鈕 */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-stone-400 hover:text-stone-600 transition-colors cursor-pointer"
                >
                    <span className="material-symbols-outlined text-xl">close</span>
                </button>

                <AuthForm
                    mode={mode}
                    onSuccess={handleSuccess}
                    onSwitchMode={() => setMode(mode === 'login' ? 'register' : 'login')}
                />
            </div>
        </div>
    );
};

AuthModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
    defaultMode: PropTypes.oneOf(['login', 'register']),
};

export default AuthModal;
